export function round1(v: number) {
  return Math.round(v * 10) / 10;
}
